import { ResourceType } from '@/types/resources';

export default {
  computed: {
    currentCard() {
      return this.$store.getters.getCardById(this.currentCardId || this.cardId || this.card.id);
    },

    cardArchived() {
      if (this.currentCard.archived) {
        return this.currentCard.type || ResourceType.Card;
      } else if (this.currentCard.archived_list) {
        return 'list';
      } else if (this.currentCard.archived_board) {
        return 'board';
      }
      return '';
    },
  },

  methods: {
    toggleArchive(cardId) {
      return this.cardArchived ? this.restoreCard(cardId) : this.archiveCard(cardId);
    },

    archiveCard(cardId) {
      return this.$store.dispatch('archiveCard', {
        cardId,
        archived: true,
      });
    },

    restoreCard(cardId) {
      return this.$store.dispatch('archiveCard', {
        cardId,
        archived: false,
      });
    },
  },
};
